export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14287.3f9c94e4.jpg";